import React from 'react';
import { Text, StyleSheet } from 'react-native';
import type { StyleProp, TextStyle } from 'react-native';
import Dimens from 'src/core/utils/Dimens';
import Fonts from 'src/core/utils/Fonts';

interface HeadingProps {
	text: string;
	styles?: StyleProp<TextStyle>;
}

export default function Heading({ text, styles: extraStyles }: HeadingProps) {
	return <Text style={[styles.heading, extraStyles]}>{text}</Text>;
}

const styles = StyleSheet.create({
	heading: {
		fontSize: Dimens.fontSize20,
		fontFamily: Fonts.montserratBold,
	},
});
